module.exports = __webpack_public_path__ + "static/media/metragem.7df50c24.svg";